import { Box, Center, SimpleGrid } from '@chakra-ui/react'
import { Fragment, useMemo } from 'react'
import { Field, Formik } from 'formik'
import { useBoolean } from 'react-use'
import { Button, Modal, SelectForm, TextAreaForm } from 'uikit'
import {
  CardContainer,
  Container,
  ContentContainer,
  ContentContainerColumn,
  Form,
  FormSection,
} from 'uikit/layout'
import * as Yup from 'yup'
import { useFetchReferralCatalog } from '../Catalog/List/services/useFetchReferralCatalog'
import { useUpdateRewards } from './services/useUpdateRewards'

const formSchema = Yup.object().shape({
  eventCode: Yup.string().required('Событие обязательное поле'),
  phones: Yup.string().required('Номера телефонов обязательное поле'),
})

export const RewardDistribution = () => {
  const [resultIsOpen, setOpenResult] = useBoolean(false)

  const { data: eventsList } = useFetchReferralCatalog()
  const { mutate: updateRewards, data, isLoading } = useUpdateRewards()

  const handleForm = ({ phones, eventCode }) => {
    const phone = phones
      .split('\n')
      .map((item) => item.trim())
      .filter((item) => !!item)

    updateRewards(
      {
        eventCode,
        phone,
      },
      {
        onSuccess: () => {
          setOpenResult(true)
        },
      }
    )
  }

  const eventsOptions = useMemo(() => {
    return eventsList
      ?.filter((item) => !item?.hidden)
      ?.map((item) => ({
        label: item.description,
        value: item.eventCode,
      }))
  }, [eventsList])

  return (
    <Container>
      <CardContainer indentTop={120} isHideBack>
        <ContentContainer>
          <ContentContainerColumn>
            <Formik
              initialValues={{}}
              enableReinitialize
              onSubmit={handleForm}
              validationSchema={formSchema}
              validateOnMount
            >
              {(props) => (
                <Form
                  onSubmit={props.handleSubmit}
                  footer={
                    <Button
                      type="submit"
                      colorPalette="orange"
                      loading={isLoading}
                      disabled={!props.isValid}
                    >
                      Отправить
                    </Button>
                  }
                >
                  <FormSection>
                    <Field
                      name="eventCode"
                      component={SelectForm}
                      label="Событие"
                      placeholder="Укажите событие"
                      disabled={isLoading}
                      options={eventsOptions}
                    />
                    <Field
                      name="phones"
                      component={TextAreaForm}
                      label="Введите номера телефонов"
                      disabled={isLoading}
                      placeholder={
                        '7932337751\n7932337752\n7932337753\n7932337754\n7932337755\n...'
                      }
                      rows={30}
                    />
                  </FormSection>
                </Form>
              )}
            </Formik>
          </ContentContainerColumn>
        </ContentContainer>
      </CardContainer>

      <Modal
        isOpen={resultIsOpen}
        onClose={() => setOpenResult(false)}
        title="Результат"
        scrollBehavior="inside"
        footer={
          <Button colorPalette="orange" onClick={() => setOpenResult(false)}>
            Закрыть
          </Button>
        }
      >
        <Box minH="200px">
          {!!data && data.length !== 0 ? (
            <SimpleGrid columns={2} gap={1}>
              <Box fontWeight="bold">Номер</Box>
              <Box fontWeight="bold">Бонус</Box>
              {data.map((item, index) => (
                <Fragment key={`${String(item.customerId)}-${index}`}>
                  <Box>{item.customerId}</Box>
                  <Box>{item.reward}</Box>
                </Fragment>
              ))}
            </SimpleGrid>
          ) : (
            <Center>Список пуст</Center>
          )}
        </Box>
      </Modal>
    </Container>
  )
}
